import React, { useState } from "react"
import CurrencyContext from "../../context/CurrencyContext"
import getCurrencyId from "../../utils/getCurrencyId"
import Pricing from "../ui/Pricing"

import { useStaticQuery, graphql } from "gatsby"

const SharedHostingPlans = () => {
  const [billingCycle, setBillingCycle] = useState("monthly") // State to track selected billing cycle
    const handleToggleBillingCycle = (cycle) => {
      setBillingCycle(cycle) // Update selected billing cycle
    }
  const allData = useStaticQuery(graphql`
    query {
      allProductsJson(filter: { pid: { in: [71, 1, 79, 12] } }) {
        edges {
          node {
            pid
            name
            description
            pricing {
              INR {
                prefix
                suffix
                monthly
                annually
              }
              MYR {
                prefix
                suffix
                monthly
                annually
              }
              SGD {
                prefix
                suffix
                monthly
                annually
              }
              USD {
                prefix
                suffix
                monthly
                annually
              }
              GBP {
                prefix
                suffix
                monthly
                annually
              }
            }
          }
        }
      }
    }
  `)
  const data = allData.allProductsJson.edges
  if (data.length <= 0) {
    return <></>
  }
  return (
    <CurrencyContext.Consumer>
      {(context) => {
        const currencyID = getCurrencyId(context)
        return (
          <div className="row ">
            {data.map((item, index) => (
              <div key={index} className="col-12 col-lg-3 ">
                <div className="card card-shadow text-start pricing border-0 position-relative py-5 px-4 mb-3">
                  <h3 className="card-title">{item.node.name}</h3>
                  <Pricing
                    CurrencyPrefix={item.node.pricing}
                    pricing={item.node.pricing}
                    productID={item.node.pid}
                    billingCycle={billingCycle} // Pass billing cycle state
                  />

                  <a
                    className="btn"
                    href={`https://my.motherhost.com/cart.php?currency=${currencyID}&a=add&pid=${item.node.pid}&billingcycle=${billingCycle}`}
                  >
                    Add to Cart
                    <i className="bi bi-arrow-right float-end"></i>
                  </a>
                  <ul
                    className="mb-2"
                    dangerouslySetInnerHTML={{
                      __html: item.node.description,
                    }}
                  ></ul>
                </div>
              </div>
            ))}
          </div>
        )
      }}
    </CurrencyContext.Consumer>
  )
}

export default SharedHostingPlans
